import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import {
  type FeatureAnnouncement,
  FeatureAnnouncementStoreService,
} from '@customer-portal/data-access/feature-announcements';
import {
  SharedButtonComponent,
  SharedButtonType,
} from '@customer-portal/shared/components/button';
import { APP_TITLE } from '@customer-portal/shared/constants';

import { FeatureAnnouncementCtaService } from '../../services/feature-announcement-cta.service';

@Component({
  selector: 'lib-whats-new-dialog',
  imports: [CommonModule, TranslocoDirective, SharedButtonComponent],
  templateUrl: './whats-new-dialog.component.html',
  styleUrl: './whats-new-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsNewDialogComponent {
  private readonly announcementStore = inject(FeatureAnnouncementStoreService);
  private readonly ctaService = inject(FeatureAnnouncementCtaService);
  private readonly dialogRef = inject(DynamicDialogRef);

  readonly activeFeatures = this.announcementStore.activeFeatures;
  readonly sharedButtonType = SharedButtonType;
  readonly portalName = APP_TITLE;

  onClose(): void {
    this.dialogRef.close();
  }

  onCta(feature: FeatureAnnouncement): void {
    this.dialogRef.close();
    this.ctaService.execute(feature);
  }
}
